// removed by extract-text-webpack-plugin
module.exports = {"noBookings":"BookingList__noBookings___1FpoT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BookingList/BookingList.css
// module id = 695
// module chunks = 0